"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestCartesian2dUpdateArgProvider = void 0;
const core_1 = require("@visualization-tools/core");
const rc_js_util_1 = require("rc-js-util");
const cartesian2d_update_arg_1 = require("../update/update-arg/cartesian2d-update-arg");
/**
 * @internal
 * Assumes a data range of 0-4 in both axis.
 */
class TestCartesian2dUpdateArgProvider {
    constructor(ctor, dims, dpr = 1) {
        this.ctor = ctor;
        this.dims = dims;
        const cssRange = rc_js_util_1.Range2d.f32.factory.createOne(0, this.dims.getX(), 0, this.dims.getY());
        const pixelRange = rc_js_util_1.Range2d.f32.factory.createOne(0, this.dims.getX() * dpr, 0, this.dims.getY() * dpr);
        this.canvasDims = new core_1.CanvasDimensions(dpr, cssRange, pixelRange, new rc_js_util_1.Range2d.f32());
    }
    createTestCartesian2dUpdateArg() {
        const arg = new cartesian2d_update_arg_1.Cartesian2dUpdateArg(this.ctor);
        arg.plotRange.update(0, 4, 0, 4);
        arg.canvasDimensions = this.canvasDims;
        const plotArea = core_1.PlotArea.createDefault();
        arg.plotDimensionsOBL = core_1.PlotDimensions.createOneOBL(plotArea, this.canvasDims);
        arg.plotDimensionsOTL = core_1.PlotDimensions.createOneOTL(plotArea, this.canvasDims);
        arg.interactionTransforms.update(arg.plotRange, arg.plotDimensionsOBL.cssArea.wholeRange, arg.plotDimensionsOBL.cssArea.interactiveRange);
        arg.drawTransforms.update(arg.plotRange, arg.plotDimensionsOBL.clipSpaceArea.wholeRange, arg.plotDimensionsOBL.clipSpaceArea.interactiveRange);
        return arg;
    }
}
exports.TestCartesian2dUpdateArgProvider = TestCartesian2dUpdateArgProvider;
//# sourceMappingURL=test-cartesian2d-update-arg-provider.js.map